import React from 'react';
import { useAccount } from '@/hooks/useAccount';
import { MainView } from '@repo/ui/Views';

import SecurityTabNav from '../components/security/SecurityTabNav';

const MfaEnforcement = () => {
  const account = useAccount();

  return (
    <MainView title="Account Security: MFA">
      <SecurityTabNav />
      {/* TODO: Add MFA enforcement content here */}
    </MainView>
  );
};

export default MfaEnforcement;
